import { useCentralStore } from "stores";
import { useEffect } from "react";
import { JournalEntriesTable } from "../components";

export const JournalEntries = () => {
  const setHeaderTitle = useCentralStore(state => state.setHeaderTitle);

  useEffect(() => {
    setHeaderTitle("Journal Entries");
    return () => setHeaderTitle("");
  }, []);

  return <JournalEntriesTable />;
};
